/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const AuthIcon = /*#__PURE__*/ createSvgIcon(
  'AuthIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M5.833 11.667c-.458 0-.85-.163-1.177-.49A1.605 1.605 0 014.166 10c0-.458.164-.85.49-1.177.327-.326.72-.49 1.178-.49.458 0 .85.164 1.177.49.326.326.49.719.49 1.177 0 .458-.164.85-.49 1.177-.327.327-.72.49-1.178.49zm0 3.333c-1.388 0-2.569-.486-3.541-1.458C1.32 12.569.833 11.389.833 10c0-1.389.487-2.57 1.459-3.542C3.264 5.486 4.445 5 5.834 5c.93 0 1.774.23 2.53.688A5.176 5.176 0 0110.168 7.5h6.979a.862.862 0 01.604.25l1.667 1.667a.73.73 0 01.177.27.923.923 0 01.052.313.923.923 0 01-.052.313.73.73 0 01-.177.27L16.77 13.23a.787.787 0 01-.25.167c-.097.041-.194.07-.292.083a.693.693 0 01-.291-.02.736.736 0 01-.271-.146l-1.083-.813-1.188.896a.785.785 0 01-.74.125.715.715 0 01-.24-.125l-1.27-.896h-.98a5.176 5.176 0 01-1.801 1.813c-.757.458-1.601.687-2.532.687zm0-1.667a3.19 3.19 0 002.053-.708 3.36 3.36 0 001.177-1.792h2.604l1.208.854 1.709-1.27 1.479 1.146L17.625 10l-.833-.833h-7.73a3.36 3.36 0 00-1.176-1.792 3.19 3.19 0 00-2.053-.708 3.21 3.21 0 00-2.354.979A3.21 3.21 0 002.5 10c0 .917.327 1.701.98 2.354a3.21 3.21 0 002.353.98z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default AuthIcon;
